// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"manFgyQabX_calculator","hasChild":"_3HTqE4YSFj_calculator","column":"_33WDEBr9-K_calculator","header":"_3m0ntRklEP_calculator","paragraph":"_1hlr46CJkt_calculator"};